export default __webpack_public_path__ + "static/media/realitybytes_m.83a82eab.jpg";